export default __webpack_public_path__ + "static/media/details.4a0288a2.svg";